import * as React from "react";
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={42} height={42} rx={4.83833} fill="#E7EBFA" />
    <G clipPath="url(#clip0_1120_7800)">
      <Path
        opacity={0.2}
        d="M29.6569 18H30C30.3978 18 30.7794 18.158 31.0607 18.4393C31.342 18.7206 31.5 19.1022 31.5 19.5V22.5C31.5 22.8978 31.342 23.2794 31.0607 23.5607C30.7794 23.842 30.3978 24 30 24H29.25L27.5531 28.7522C27.5011 28.898 27.4052 29.0241 27.2786 29.1132C27.1521 29.2023 27.001 29.2501 26.8463 29.25H25.6538C25.499 29.2501 25.3479 29.2023 25.2214 29.1132C25.0948 29.0241 24.9989 28.898 24.9469 28.7522L24.5897 27.75H18.1603L17.8031 28.7522C17.7511 28.898 17.6552 29.0241 17.5286 29.1132C17.4021 29.2023 17.251 29.2501 17.0963 29.25H15.9038C15.749 29.2501 15.5979 29.2023 15.4714 29.1132C15.3448 29.0241 15.2489 28.898 15.1969 28.7522L13.9688 25.3125C12.7006 23.9317 11.9979 22.1247 12 20.25C12 18.2609 12.7902 16.3532 14.1967 14.9467C15.6032 13.5402 17.5109 12.75 19.5 12.75H22.5C23.9635 12.7496 25.3952 13.1774 26.6186 13.9806C27.842 14.7839 28.8036 15.9275 29.385 17.2706C29.4879 17.509 29.5786 17.7525 29.6569 18Z"
        fill="#1434CB"
      />
      <Path
        d="M25.875 21C26.4963 21 27 20.4963 27 19.875C27 19.2537 26.4963 18.75 25.875 18.75C25.2537 18.75 24.75 19.2537 24.75 19.875C24.75 20.4963 25.2537 21 25.875 21Z"
        fill="#1434CB"
      />
      <Path
        d="M19.5 15.75H23.25"
        stroke="#1434CB"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M29.25 12.75H22.5"
        stroke="#1434CB"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M9.75 22.5C9.75 21.9033 9.98705 21.331 10.409 20.909C10.831 20.4871 11.4033 20.25 12 20.25"
        stroke="#1434CB"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M29.6569 18H30C30.3978 18 30.7794 18.158 31.0607 18.4393C31.342 18.7206 31.5 19.1022 31.5 19.5V22.5C31.5 22.8978 31.342 23.2794 31.0607 23.5607C30.7794 23.842 30.3978 24 30 24H29.25L27.5531 28.7522C27.5011 28.898 27.4052 29.0241 27.2786 29.1132C27.1521 29.2023 27.001 29.2501 26.8463 29.25H25.6538C25.499 29.2501 25.3479 29.2023 25.2214 29.1132C25.0948 29.0241 24.9989 28.898 24.9469 28.7522L24.5897 27.75H18.1603L17.8031 28.7522C17.7511 28.898 17.6552 29.0241 17.5286 29.1132C17.4021 29.2023 17.251 29.2501 17.0963 29.25H15.9038C15.749 29.2501 15.5979 29.2023 15.4714 29.1132C15.3448 29.0241 15.2489 28.898 15.1969 28.7522L13.9688 25.3125C12.7006 23.9317 11.9979 22.1247 12 20.25C12 18.2609 12.7902 16.3532 14.1967 14.9467C15.6032 13.5402 17.5109 12.75 19.5 12.75H22.5C23.9635 12.7496 25.3952 13.1774 26.6186 13.9806C27.842 14.7839 28.8036 15.9275 29.385 17.2706C29.4879 17.509 29.5786 17.7525 29.6569 18Z"
        stroke="#1434CB"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_1120_7800">
        <Rect width={24} height={24} fill="white" transform="translate(9 9)" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
